export const FLAG_GETTING_MATERIALS = 'FLAG_GETTING_MATERIALS';
export const GET_MATERIALS = 'GET_MATERIALS';
export const CLEAR_MATERIALS = 'CLEAR_MATERIALS';
export const FLAG_MATERIAL_ACTIVITY = 'FLAG_MATERIAL_ACTIVITY';
export const GET_MATERIAL = 'GET_MATERIAL';
export const CLEAR_MATERIAL = 'CLEAR_MATERIAL';
